import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { adminTemplateState } from "../types/index"
import { initialState } from "./initialState";

const getAdminTemplateState = (state: RootState) => state.adminTemplateState || initialState



export const selectTemplates = createSelector(
    [getAdminTemplateState],
    (adminTemplateState: adminTemplateState) => adminTemplateState.data 

)

export const selectIsLoading = createSelector(
    [getAdminTemplateState],
    (adminTemplateState: adminTemplateState) => adminTemplateState.loading   

)

export const selectIsSaving = createSelector(
    [getAdminTemplateState],
    (adminTemplateState: adminTemplateState) => adminTemplateState.saving
)

export const selectError = createSelector(
     [getAdminTemplateState],
    (adminTemplateState: adminTemplateState) => adminTemplateState.error

)

export const selectFormData = createSelector(
    [getAdminTemplateState],
    (adminTemplateState: adminTemplateState) => adminTemplateState.formData
);

export const selectIsAddModalOpen = createSelector(
    [getAdminTemplateState],
    (adminTemplateState: adminTemplateState) => adminTemplateState.isAddModalOpen
);

export const selectPendingForm = createSelector(
    [getAdminTemplateState],
    (adminTemplateState: adminTemplateState) => adminTemplateState.formData
);